import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const CentroTrabajoRepositorioJuridicoService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Centro_Trabajo_Repositorio_Juridico_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			centro_trabajo: form.centro_trabajo,
			direccion: form.direccion,
			abreviacion: form.abreviacion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Centro_Trabajo_Repositorio_Juridico_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_centro_trabajo_repositorio_juridico: form.id_cat_centro_trabajo_repositorio_juridico,
			centro_trabajo: form.centro_trabajo,
			direccion: form.direccion,
			abreviacion: form.abreviacion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Centro_Trabajo_Repositorio_Juridico_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_centro_trabajo_repositorio_juridico) => {
		let params = {
			id_cat_centro_trabajo_repositorio_juridico: id_cat_centro_trabajo_repositorio_juridico
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Centro_Trabajo_Repositorio_Juridico_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
